import { render, staticRenderFns } from "./BaseQuickMenuSidebar.vue?vue&type=template&id=1f711c82&scoped=true"
import script from "./BaseQuickMenuSidebar.vue?vue&type=script&lang=js"
export * from "./BaseQuickMenuSidebar.vue?vue&type=script&lang=js"
import style0 from "./BaseQuickMenuSidebar.vue?vue&type=style&index=0&id=1f711c82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f711c82",
  null
  
)

export default component.exports